import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import {
  CreateCompanyAddressResponse,
  FetchCompanyAddressesResponse,
  UpdateCompanyAddressResponse,
} from '../../../types/companyAddress';
import {
  createCompanyAddress,
  deleteCompanyAddress,
  fetchCompanyAddresses,
  updateCompanyAddress,
} from './companyAddress.actions';
import { CompanyAddressState } from './companyAddress.types';

const initialState: CompanyAddressState = {
  companyAddresses: [],
  editCompanyAddress: null,
  totalCompanyAddresses: 0,
  fetchStatus: fetchStatuses.idle,
  deleteStatus: fetchStatuses.idle,
  updateStatus: fetchStatuses.idle,
  createStatus: fetchStatuses.idle,
  error: null,
};

const companyAddressSlice = createSlice({
  name: 'companyAddress',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyAddresses.pending, (state) => {
      state.fetchStatus = fetchStatuses.pending;
      state.deleteStatus = fetchStatuses.idle;
      state.updateStatus = fetchStatuses.idle;
      state.createStatus = fetchStatuses.idle;
    });
    builder.addCase(fetchCompanyAddresses.fulfilled, (state, action: PayloadAction<FetchCompanyAddressesResponse>) => {
      state.companyAddresses = action.payload.data?.items ?? [];
      state.totalCompanyAddresses = action.payload.data?.totalItems ?? 0;
      state.fetchStatus = fetchStatuses.success;
    });
    builder.addCase(fetchCompanyAddresses.rejected, (state, action) => {
      state.fetchStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(createCompanyAddress.pending, (state) => {
      state.error = null;
      state.createStatus = fetchStatuses.pending;
    });
    builder.addCase(createCompanyAddress.fulfilled, (state, action: PayloadAction<CreateCompanyAddressResponse>) => {
      state.editCompanyAddress = action.payload.data;
      state.createStatus = fetchStatuses.success;
    });
    builder.addCase(createCompanyAddress.rejected, (state, action) => {
      state.createStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(updateCompanyAddress.pending, (state) => {
      state.error = null;
      state.updateStatus = fetchStatuses.pending;
    });
    builder.addCase(updateCompanyAddress.fulfilled, (state) => {
      state.updateStatus = fetchStatuses.success;
    });
    builder.addCase(updateCompanyAddress.rejected, (state, action) => {
      state.updateStatus = fetchStatuses.rejected;
      state.error = action.error;
    });

    builder.addCase(deleteCompanyAddress.pending, (state) => {
      state.error = null;
      state.deleteStatus = fetchStatuses.pending;
    });
    builder.addCase(deleteCompanyAddress.fulfilled, (state) => {
      state.editCompanyAddress = null;
      state.deleteStatus = fetchStatuses.success;
    });
    builder.addCase(deleteCompanyAddress.rejected, (state, action) => {
      state.deleteStatus = fetchStatuses.rejected;
      state.error = action.error;
    });
  },
});

export const companyAddressReducer = companyAddressSlice.reducer;
